import type { Gradient } from '@jouzen/ecom-components';

const CLASS_NAME = 'hidden lg:block';

const activityAndMovementFeaturesGradients: Gradient[] = [
  {
    shape: 'ellipse',
    hex: '#E09666',
    id: 'orange-1',
    position: [15, 90],
    opacity: 0.8,
    size: 50,
    className: CLASS_NAME,
  },
  {
    shape: 'circle',
    hex: '#E09666',
    id: 'orange-2',
    position: [90, 40],
    opacity: 0.5,
    size: 35,
    className: CLASS_NAME,
  },
];

export default activityAndMovementFeaturesGradients;
